"use client"
import { Metadata } from "next"
import { useEffect } from "react"
import Heading from "../_components/Atoms/Heading"
import StoryText from "../_components/Atoms/Storytext"
import ButtonLink from "../_components/Molecules/ButtonLink"

export const metadata: Metadata = {
    title: "Not Found",
    description: "Could not find requested resource"
}

export default function NotFound() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div className="flex h-[80vh] flex-col items-center justify-center p-24 py-64">
            <Heading type="h1" className="mb-12">
                NOT FOUND
            </Heading>
            <StoryText size="size2" className="mb-24">
                Could not find requested resource
            </StoryText>
            <ButtonLink
                href="/"
                prefetch={false}
                color="black"
                size="large"
                variant="primary"
            >
                Return Home
            </ButtonLink>
        </div>
    )
}
